class FilterOptionsWrapper extends HTMLElement {

  constructor() {
    super();
    
    const filterButton = this.querySelector('[data-filter-button]');
    const watch = document.getElementById('shopify-section-footer');

    function obCallback(payload) {
    
      // if footer is on the screen
      if (payload[0].isIntersecting && payload[0].intersectionRatio > 0) {
        filterButton.classList.add('is-absolute');
      
      // if footer is off the screen
      } else  {
        filterButton.classList.remove('is-absolute');
      }
    }

    // observe
    const ob = new IntersectionObserver(obCallback);
    ob.observe(watch);
  }

}

if (!customElements.get('filter-options-wrapper')) {
  customElements.define('filter-options-wrapper', FilterOptionsWrapper);
}
